import { localeSelector } from 'domain/env';

import { handleImport } from 'lib/import';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/he';
import '@formatjs/intl-pluralrules/locale-data/es';
import '@formatjs/intl-pluralrules/locale-data/it';
import '@formatjs/intl-pluralrules/locale-data/fr';

const TRANSLATION = {
  en: () => handleImport(import('./en')),
  uk: () => handleImport(import('./en')),
  he: () => handleImport(import('./he')),
  es: () => handleImport(import('./es')),
  it: () => handleImport(import('./it')),
  fr: () => handleImport(import('./fr')),
};

export default function intl(store) {
  const locale = localeSelector(store.getState());
  return Promise.all([TRANSLATION[locale]()]).then((res) => ({ locale, translation: res[0].default }));
}
